var ValueJS = ValueJS || {};

ValueJS.Facets = function() {

    var _selector = {
        'filter': '.offcanvas--facets .btn-check',
        'sort': '.offcanvas--facets .form-select',
    };

    var _initialized = false;

    var _sizeFilters = $('.offcanvas--facets input[name="filter.v.option.size"]');
    var _colorFilters = $('.offcanvas--facets input[name="filter.v.option.color"]');

    var _init = function() {
        if (!_initialized) {
            $(_selector.filter + ', ' + _selector.sort).on('change', function() {
                if (_sizeFilters.filter(':checked').length || _colorFilters.filter(':checked').length) {
                }
                $(this).parents('form').trigger('submit');
            });
            _initialized = true;
        }
    }

    var _domUpdate = function() {
        _initialized = false;
        _init();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    ValueJS.Facets.init();
});
